import { render, staticRenderFns } from "./ViewConfig.vue?vue&type=template&id=7d53b190"
import script from "./ViewConfig.vue?vue&type=script&lang=js"
export * from "./ViewConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports